import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

function Testimonials({ data }) {
  let testimonialsList = [];
  
  if (data) {
    if (Array.isArray(data)) {
      testimonialsList = data;
    } else if (data.testimonials && Array.isArray(data.testimonials)) {
      testimonialsList = data.testimonials;
    }
  }

  if (testimonialsList.length === 0) {
    return null;
  }

  return (
    <section 
      id="testimonials" 
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.35)), url(${process.env.PUBLIC_URL}/images/header-background4.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="text-container">
        <div className="row">
          <div className="two columns header-col">
            <h1><span>Testimonial <br/> What my students say</span></h1>
          </div>
          <div className="ten columns flex-container">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              autoplay={{
                delay: 6000,
                disableOnInteraction: false,
              }}
              pagination={{ 
                clickable: true
              }}
              loop={testimonialsList.length > 1}
            >
              {testimonialsList.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-content">
                    <div className="quote-icon">"</div>
                    <img
                      className="profile-pic"
                      src={testimonial.avatar}
                      alt={testimonial.user}
                    />
                    <blockquote>
                      <p>{testimonial.text}</p>
                      <cite>— {testimonial.user}{testimonial.location ? `, ${testimonial.location}` : ''}</cite>
                    </blockquote>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
